<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧社区</h2>
        <h3>智慧大屏</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview mb100">
        <div>
          <h2>智慧大屏</h2>
          <p>社区数据分类型进行统计，包括人口、房屋、事件、设备等数据的展示， 实时的告警信息提示，快捷的告警信息指派处理，整合小区各类物联网硬件、 物业和网格管理机制和视频追溯能力，实现小区的综合智能监管，时刻为社 区的安全保驾护航。 展示数据包括：小区数据、房屋数据、人口数据、居民联系方式、人防数据、物 防数据、技防数据、安防巡更、社区特殊群体。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScintelligentScreen',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/background_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
</style>
